import PropTypes from 'prop-types';
import {Component} from 'react';
import {Checkbox, Image} from 'semantic-ui-react';
import BinIcon from '../images/sectionBin.svg';

export default class ReportSectionToggle extends Component {
  static propTypes = {
    included: PropTypes.bool,
    sectionUrl: PropTypes.string,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.included || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.included !== this.props.included) {
      this.setState({isChecked: this.props.included});
    }
  }

  toggled = () => {
    const {onClick} = this.props;
    const {isChecked} = this.state;

    onClick(!isChecked);
    this.setState({isChecked: !isChecked});
  };

  render() {
    const {onDelete, sectionUrl} = this.props;
    const {isChecked} = this.state;

    return (
      <div className="report-section-actions">
        {sectionUrl && <Image className="report-section-remove" size="tiny" src={BinIcon} onClick={onDelete}/>}
        <Checkbox className="report-section-toggle" onChange={this.toggled} checked={isChecked}/>
      </div>
    );
  }
}
